export default {
    data() {
        return  {
            fetchDataInterval: null,
        }
    },
    methods: {
        async getDataWithRefreshInterval (mainFunc, additionalFunc) {
            if (this.fetchDataInterval) {
                clearTimeout(this.fetchDataInterval)
            }
            if (this.abortController) {
                this.abortController.abort()
                this.abortController = new AbortController()
            }
            const startTime = (new Date()).getTime()

            try {
                if (mainFunc && typeof mainFunc === 'function') {
                    await mainFunc()
                } else if (this.getWidgetData) {
                    await this.getWidgetData()
                }
            } catch (e) {
                console.error(e)
            }

            const finishTime = (new Date()).getTime()
            const requestTimeDiff = finishTime - startTime

            try {
                if (additionalFunc && typeof additionalFunc === 'function') {
                    await additionalFunc()
                }
            } catch (e) {
                console.error(e)
            }

            const widgetLayoutRefreshInterval = this.data.WidgetLayout.DefaultRefreshInterval * 1000
            const refreshIntervalFromWidget = widgetLayoutRefreshInterval || this.data.DefaultRefreshInterval
            const minimumRefreshInterval = requestTimeDiff * 0.2
            const refreshInterval = refreshIntervalFromWidget < minimumRefreshInterval
                ? minimumRefreshInterval : refreshIntervalFromWidget

            if (refreshInterval) {
                this.fetchDataInterval = setTimeout(this.getDataWithRefreshInterval, refreshInterval)
            }
        }
    },
    beforeDestroy() {
        if (this.fetchDataInterval) {
            clearTimeout(this.fetchDataInterval)
        }
    },
}
